import countries from '../assets/json/countries.json';

const UPS_FILTER_BY_COUNTRY_NAME = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'France',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Germany',
  'Poland',
  'Netherlands',
  'Romania',
  'Slovenia',
  'Slovakia',
  'Hungary',
  'Italy',
];
const ENDPOINTS = {
  getLocations: '/get-locations',
};

const upsCountries = countries.filter((country) =>
  UPS_FILTER_BY_COUNTRY_NAME.includes(country.name),
);

// The UPS host, the OAuth token manager and the locator payload now live in
// `server/utils/ups.js` — they are only ever used by the Nitro routes
export { ENDPOINTS, upsCountries };
